import React from 'react';

import './BlueLine.css';

const BlueLine = () => {
    return (
        <div className="BlueLine" />
    )
}

export default BlueLine;